import styled, { css } from "styled-components";
import { EmbedMode, EmbedTheme } from "../../utils/embeds";
import { FontSharedStylingProps} from "../Typography";
import { EmbedWithClamp } from "../V3EmbedCollection/V3EmbedCollection.styles";
import { ClampMixin } from "../ReusableStyledComponents/ClampMixin";
import { AuthoryColorSchemeProps, UserThemableParagraph } from "../ReusableStyledComponents/FontSetUtilities";

const BackgroundImageMixin = css<{ $imgSrc?: string }>`
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url(${({ $imgSrc }) => $imgSrc});
    position: relative;

    &:before {
        display: ${({ $imgSrc }) => !!$imgSrc ? "block" : "none"};
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(8, 22, 43, 0.7);
        border-radius: 18px;
        border-radius: ${({ $imgSrc }) => !!$imgSrc ? "18px 18px 0 0" : "18px"};
    }

    > * {
        position: relative;
        z-index: 1;
    }
`

export const V3EmbedProfileFooter = styled.div`
    margin-top: 28px;

    * {
        color: white;
        stroke: white;
    }
`;

export const V3EmbedProfileNoItemsImageWrapper = styled.div<{ $imgSrc?: string }>`
    ${BackgroundImageMixin};
    border-radius: 18px;
    padding: ${({ $imgSrc }) => !!$imgSrc ? "20px" : 0};
`;

export const V3EmbedProfileContent = styled.div<{ $embedMode: EmbedMode, $imgSrc?: string }>`
    display: flex;
    flex-direction: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "row" : "column"};
    justify-content: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "flex-start" : "center"};
    align-items: center;
    text-align: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "left" : "center"};
    border-radius: ${({ $imgSrc }) => !!$imgSrc ? "18px 18px 0 0" : undefined};
    padding: ${({ $imgSrc }) => !!$imgSrc ? "20px" : 0};
    ${BackgroundImageMixin};

    > div {
        &:first-child {
            margin-right: ${({ $embedMode }) => $embedMode === EmbedMode.compact ? "24px" : undefined};
        }
    }

    a {
        display: inline-flex;
    }
`;

export const V3EmbedProfileAvatarWrapper = styled.div`
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
`;

const UserThemableProfileBio = styled.div<AuthoryColorSchemeProps>`
    ${UserThemableParagraph}
`;

export const V3EmbedProfileBio = styled(UserThemableProfileBio)<EmbedWithClamp & AuthoryColorSchemeProps & FontSharedStylingProps>`
    font-size: 14px;
    line-height: 20px;
    ${ClampMixin};
`;

export const V3EmbedProfileItemsImageWrapper = styled.div<{ $embedTheme?: EmbedTheme }>`
    padding: 20px;
    background: ${({ $embedTheme, theme }) => $embedTheme === EmbedTheme.dark ? theme.v3.colors.ink : "white"};
    border-radius: 0 0 18px 18px;
`;